
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Apri il menu del tuo browser`,
's182ab2d6c997515f': `Aggiungilo alla schermata principale per un'esperienza più completa e un accesso facile.`,
's1b9047d53d9f9d22': `2) Premi Condividi nella barra di navigazione`,
's2d90afa5dcca2c0e': `3) Scorri verso il basso fino a "Aggiungi alla schermata principale"`,
's37a9e8aec5713460': `Più`,
's4593f304dac8848c': `2) Tocca "Aggiungi alla schermata principale"`,
's54cfbb14f46396d4': `1) Apri nel tuo browser principale`,
's6196153c4b0c1ea0': `Installa`,
's922329d6f6213590': `Aggiungi al Dock`,
'sa5ef80b4bb9b39f8': `Meno`,
'sa7551383d1897fcc': `2) Premi Aggiungi al Dock`,
'sba52286c21552a4e': `Installalo sul tuo dispositivo per un'esperienza più completa e un accesso facile.`,
'sc79fd7641eb9a975': `Nascondi istruzioni`,
'scdaf4bbff76674c8': `Aggiungi alla schermata principale`,
'se740f75b95a51807': `Aggiungilo al Dock per un'esperienza più completa e un accesso facile.`,
'sfea652f6580ff086': `Questo sito ha funzionalità di app.`,
    };
  